import PostDetail from './PostDetail';

export default PostDetail;
